import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import { paths } from '@src/routes/paths';
import { LoadingScreen } from '@syntra/ui/components/loading-screen';

import DashboardLayout from 'src/layouts/dashboard';
import { FeatureFlag } from 'src/auth/feature-flags';
import { AuthGuard, OnboardingGuard } from 'src/auth/guard';
import FeatureFlagGuard from 'src/auth/guard/feature-flag-guard';

// ----------------------------------------------------------------------

const IndexPage = lazy(() => import('../pages/CompanyManagmentDashboardIndexPage'));

// ----------------------------------------------------------------------
export const companyManagmentDashboardRoutes = [
  {
    path: `${paths.dashboard.company_managment_dashboard.index}`,
    element: (
      <AuthGuard>
        <OnboardingGuard>
          <FeatureFlagGuard flag={FeatureFlag.CompanyDashboard}>
            <DashboardLayout>
              <Suspense fallback={<LoadingScreen />}>
                <Outlet />
              </Suspense>
            </DashboardLayout>
          </FeatureFlagGuard>
        </OnboardingGuard>
      </AuthGuard>
    ),
    children: [{ element: <IndexPage />, index: true }],
  },
];
